module.exports = __webpack_public_path__ + "music.ff8b0859f5762b151838.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/music/webfont/music.eot
// module id = ../../../../../src/assets/fonts/line-icons-pro/music/webfont/music.eot
// module chunks = styles